import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { useEffect, useState } from "react";

export const AnimatedTelesales = ({ onClick }: { onClick: () => void }) => {
  const [animationState, setAnimationState] = useState("icon");

  useEffect(() => {
    const timer1 = setTimeout(() => {
      setAnimationState("text");
    }, 2000); // Show text after 2 second

    const timer2 = setTimeout(() => {
      setAnimationState("icon");
    }, 6000); // Return to icon after another 3 seconds

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
    };
  }, []);

  return (
    <Button
      StartIcon={
        <MaterialIcon
          className="absolute right-3 top-2 text-2xl"
          name="phone_enabled"
        />
      }
      children={animationState === "text" ? "رزرو تلفنی" : undefined}
      className={`shadow-4 !fixed bottom-[80px] left-0 z-[12] flex items-center justify-center gap-3 rounded-full !rounded-l-none bg-white px-4 py-2 transition-all duration-1000 ease-in-out ${
        animationState === "text"
          ? "w-[150px] translate-y-0 opacity-100"
          : "w-[50px] translate-y-0 opacity-100"
      }`}
      color="secondary"
      onClick={onClick}
      size="large"
      variant="round"
    />
  );
};
